import React from 'react'
import CardSrc from '../../assets/images/promos/card.jpg'
import CardSrcWebp from '../../assets/images/promos/card.webp'

const CreditCardContent = {
  creditCard: {
    titleText: (
      <>
        The Priceline Rewards<sup>™</sup> Visa<sup>®</sup> Card
      </>
    ),
    bodyText: (
      <>
        Earn $100 Statement Credit after your first purchase on Priceline. Plus,
        get VIP Gold Status once approved.
      </>
    ),
    buttonText: 'Learn More',
    image: CardSrc,
    imageWebP: CardSrcWebp,
    legalText: (
      <>
        *See{' '}
        <a href="https://www.barclaycardus.com/apply/action/tncContent?prodidreq=CCVVS75544">
          Terms and Conditions
        </a>{' '}
        for details.
      </>
    ),
    buttonLink:
      'https://www.pricelinevisa.com/apply/Landing.action?campaignId=2566&cellNumber=6&referrerid=HOMEPAGE'
  }
}

export default CreditCardContent
